import { BulkPricingRule } from '@models';

type ApplicableType = {
  type: string;
  amount: number;
};

// Check what rule, if any, applies to the quantity
export const getUnitPrice: (quantity: number, productPrice?: number, rules?: BulkPricingRule[]) => number = (
  quantity,
  productPrice = 0,
  rules,
) => {
  const applicableRule: ApplicableType = rules?.find(
    (rule) => quantity >= rule.quantity_min && (rule.quantity_max === 0 || quantity <= rule.quantity_max),
  ) ?? { type: '', amount: 0 };

  switch (applicableRule.type) {
    case 'fixed':
      return applicableRule.amount;
    case 'percent':
      return productPrice * (1 - applicableRule.amount / 100);
    case 'price':
    default:
      return productPrice - applicableRule.amount;
  }
};
